import { lazy } from 'react';
import { V9_JOURNEY_PATH } from '@/services/constants';
import Address from '@/pages/Address';

const importContact = () => import('@/pages/Contact');
const importInfo = () => import('@/pages/Info');
const importSignV9 = () => import('@/pages/SignV9');
const importFinishScreen = () => import('@/pages/FinishScreen');
const importCreditCheckEquifax = () => import('@/pages/CreditReport/credit-report');
const importExperian = () => import('@/pages/CreditReport/credits-report');
const importOtp = () => import('@/components/Otp');
const importLuminateIDV = () => import('@/pages/LuminateIdv');
const importAlreadyFiled = () => import('@/pages/AlreadyFiled');
const importViewthru = () => import('@/pages/CreditReport/creditv-report');
const importCreditHistoryEquifax = () => import('@/pages/CreditReport/CreditHistoryEquifax');

const Contact = lazy(importContact);
const Info = lazy(importInfo);
const SignV9 = lazy(importSignV9);
const FinishScreen = lazy(importFinishScreen);
const CreditCheckEquifax = lazy(importCreditCheckEquifax);
const Experian = lazy(importExperian);
const Otp = lazy(importOtp);
const LuminateIDV = lazy(importLuminateIDV);
const AlreadyFiled = lazy(importAlreadyFiled);
const Viewthru = lazy(importViewthru);
const CreditHistoryEquifax = lazy(importCreditHistoryEquifax);

export const preloadJourneyChunks = () => {
  importContact();
  importInfo();
  importSignV9();
  importFinishScreen();
  importCreditCheckEquifax();
  importExperian();
  importOtp();
  importLuminateIDV();
  importAlreadyFiled();
  importViewthru();
  importCreditHistoryEquifax();
};

const JOURNEY_PAGES: Record<string, { path: string; component: React.ReactNode; title: string }> = {
  ADDRESS: {
    path: `/${V9_JOURNEY_PATH}/address`,
    component: <Address />,
    title: 'Address',
  },
  INFO: {
    path: `/${V9_JOURNEY_PATH}/info`,
    component: <Info showMaidenName />,
    title: 'Info',
  },
  CONTACT: {
    path: `/${V9_JOURNEY_PATH}/contact`,
    component: <Contact />,
    title: 'Contact',
  },
  SIGN_FINAL: {
    path: `/${V9_JOURNEY_PATH}/sign`,
    component: <SignV9 />,
    title: 'Sign',
  },
  EXPERIAN: {
    path: `/${V9_JOURNEY_PATH}/credits-report`,
    component: <Experian />,
    title: 'Credits Report',
  },
  EQUIFAX: {
    path: `/${V9_JOURNEY_PATH}/credit-report`,
    component: <CreditCheckEquifax />,
    title: 'Credit Report',
  },
  EQUIFAX_STEALTH: {
    path: `/${V9_JOURNEY_PATH}/credit-report-s`,
    component: <CreditCheckEquifax stealthMode />,
    title: 'Credit Report',
  },
  VIEW_THRU: {
    path: `/${V9_JOURNEY_PATH}/creditv-report`,
    component: <Viewthru />,
    title: 'Credit Report',
  },
  EQUIFAX_INFO: {
    path: `/${V9_JOURNEY_PATH}/credit-report-eg`,
    component: <CreditHistoryEquifax />,
    title: 'Equifax Report',
  },
  FINISH_SCREEN: {
    path: `/${V9_JOURNEY_PATH}/submit-claim`,
    component: <FinishScreen />,
    title: 'Finish Screen',
  },
  OTP: {
    path: `/${V9_JOURNEY_PATH}/otp`,
    component: <Otp />,
    title: 'OTP',
  },
  LUMINATE_IDV: {
    path: `/${V9_JOURNEY_PATH}/questions`,
    component: <LuminateIDV />,
    title: 'Luminate IDV',
  },
  ALREADY_FILED: {
    path: `/${V9_JOURNEY_PATH}/already-filed`,
    component: <AlreadyFiled />,
    title: 'Already Filed',
  },
};

export default JOURNEY_PAGES;
